import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import * as actionTypes from "../../../store/Actions/actions";
import "./AddToolForElements.scss";

class AddToolForElements extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showToolsSection: false,
    };
    this.wrapperRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside, { capture: true });
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside, { capture: true });
  }

  handleClickOutside = (event) => {
    if (
      this.wrapperRef &&
      !this.wrapperRef.current?.contains(event.target) &&
      !event.target.closest('.addToolDiv') // Ignora clics en addToolDiv
    ) {
      this.setState({ showToolsSection: false });
      this.props.setBlockClicked?.();
    }
  };

  openShowTools = (e) => {
    e.stopPropagation();
    e.preventDefault();
    console.log('openShowTools', e);
    this.setState((prevState) => ({
      showToolsSection: !prevState.showToolsSection,
    }));
  };

  render() {
    const isElementRow = this.props.layout.findIndex(
      (item) => item && item.id === this.props.ID
    );
    return (
      <>
        <div
          className="addToolDiv"
          onClick={this.openShowTools}
          onMouseDown={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
        >
          <span>
            <i className="fa fa-plus" aria-hidden="true"></i>
          </span>
        </div>
        <div
          className={`add-tool-section ${
            this.state.showToolsSection || this.props.blockClicked ? "d-block" : ""
          }`}
        >
          <div
            ref={this.wrapperRef}
            className="addToolDiv--wrapper add-tool-for-elements"
          >
            {this.state.showToolsSection && (
              <div className="add-tool-popover">
                <div className="tool-container row">
                  <div className="tool-wrapper">
                    {this.props.tool.map((item, index) => (
                      <div
                        key={index}
                        id={index}
                        className={`col-md-4 tool-icon ${item.title}`}
                      >
                        <div
                          className={item.title}
                          id={index}
                          onClick={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            this.setState({ showToolsSection: false });
                            this.props.onAddElementorColumn(
                              event,
                              "tools",
                              item,
                              this.props.element.id
                            );
                          }}
                        >
                          {item.name}
                        </div>
                      </div>
                    ))}
                    {this.props.tool.some(
                      (item) => item.data === "Accordion" || item.data === "Row"
                    ) && (
                      <div
                        key={this.props.tool.length + 1}
                        id={this.props.tool.length + 1}
                        className="col-md-12 text-center tool-icon Block"
                      >
                        <div
                          className="Block"
                          id={this.props.tool.length + 1}
                          onClick={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            this.setState({ showToolsSection: false });
                            this.props.onAddElementorColumn(
                              event,
                              "block",
                              null,
                              this.props.element.id
                            );
                          }}
                        >
                          Block
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    layout: state.present.layout,
    glblClrs: state.present.colorsGlobal,
    preset: state.present.preset,
    containerBg: state.present.containerBgColor,
    containerWidth: state.present.containerWidth,
    pixel: state.present.pixel,
    percentage: state.present.percentage,
    imagesGlobal: state.present.imagesGlobal,
    bgImage: state.present.bgImage,
    bgImageId: state.present.bgImageId,
    bgImageIndex: state.present.bgImageIndex,
    layoutTitle: state.present.layoutTitle,
    selectedFont: state.present.selectedFont,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    pushGlobalColorArray: (colorGlobal) =>
      dispatch(actionTypes.global_colors(colorGlobal)),
    pushGlobalColorPreset: (presetColor) =>
      dispatch(actionTypes.preset(presetColor)),
    pushBgColor: (color) => dispatch(actionTypes.add_bg(color)),
    pushSelectedFont: (font) => dispatch(actionTypes.add_font(font)),
    pushContainerWidth: (width) => dispatch(actionTypes.container_width(width)),
    pushPixel: (pixelVal) => dispatch(actionTypes.pixel(pixelVal)),
    pushPercentage: (percentageVal) =>
      dispatch(actionTypes.percentage(percentageVal)),
    pushBGimage: (image, id) => dispatch(actionTypes.bg_image(image, id)),
    pushBGImages: (images) => dispatch(actionTypes.bg_images(images)),
    pushBGIndex: (index) => dispatch(actionTypes.bg_image_index(index)),
    layoutArray: (titleValue, layoutVal) =>
      dispatch(
        actionTypes.layout({ titleLayout: titleValue, layout: layoutVal })
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddToolForElements);
